import { ModalContent, ModalCloseButton, ModalHeader, Stack } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { FormikRadio } from 'components/Formik';
import { ControllableModal } from 'components/Modal';

import { initialTrackMileageModal, trackMileageValidationSchema } from './schema';

interface IJobTrackMileageModal {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  handleFormSubmit: (values: typeof initialTrackMileageModal) => void;
}

const JobTrackMileageModal: React.FC<IJobTrackMileageModal> = ({ isOpen, onClose, handleFormSubmit, isLoading }) => {
  const { t } = useTranslation(['jobsTasks', 'common']);
  return (
    <ControllableModal isOpen={isOpen} onClose={onClose} size="md">
      <ModalContent p="6" pt="2" textAlign="center">
        <ModalCloseButton />
        <ModalHeader>{t('jobsTasks:trackMileageModalTitle')}</ModalHeader>
        <Formik
          initialValues={initialTrackMileageModal}
          validationSchema={trackMileageValidationSchema}
          onSubmit={handleFormSubmit}
        >
          <Form>
            <FormikRadio
              options={[
                { label: t('jobsTasks:trackMileageForAllSelectedJobs'), value: '1' },
                { label: t('jobsTasks:untrackMileageForAllSelectedJobs'), value: '0' },
              ]}
              name="trackMileage"
            />
            <Stack direction="row" justifyContent="center" mt="6">
              <Button variant="ghost" width="170px" onClick={onClose}>
                {t('common:cancel')}
              </Button>
              <Button
                type="submit"
                width="170px"
                fontWeight="semibold"
                isLoading={isLoading}
                bg="rgba(72,82, 175, 0.1)"
                color="primary.500"
                _hover={{
                  bg: 'rgba(72,82, 175, 0.2)',
                }}
                _active={{
                  bg: 'rgba(72,82, 175, 0.2)',
                }}
              >
                {t('common:save')}
              </Button>
            </Stack>
          </Form>
        </Formik>
      </ModalContent>
    </ControllableModal>
  );
};

export default memo(JobTrackMileageModal);
